import type { Insight } from '../types/content';

export const insights: Insight[] = [
  {
    slug: 'ceo-succession-starts-earlier',
    title: 'CEO succession starts earlier than most boards think',
    category: 'Board Advisory',
    date: '2026-09-18',
    readTime: '6 min read',
    excerpt:
      'The strongest transitions begin three to five years before the announcement. Here is how leading boards structure the work.',
    body: [
      'Boards that handle chief executive succession well treat it as a continuous discipline rather than an event. They revisit the profile of their next leader as strategy evolves, and they test internal candidates against it long before a decision is needed.',
      'The most common failure we see is a profile written for the business as it is today. A successor will lead the organization through the next decade, so the brief should reflect where the company is going — its markets, its capital needs, and the culture it intends to build.',
      'Practically, this means an annual succession review, external benchmarking of internal candidates every 18 to 24 months, and an emergency plan that names an interim leader and a process. None of it is visible to the market, but all of it shapes the outcome.',
    ],
  },
  {
    slug: 'the-modern-cfo-mandate',
    title: 'The modern CFO mandate: beyond stewardship',
    category: 'C-Suite',
    date: '2026-08-27',
    readTime: '5 min read',
    excerpt:
      'Finance chiefs are increasingly hired as strategic operators. What that shift means for how organizations search.',
    body: [
      'Ten years ago, most CFO searches prioritized control, reporting, and capital markets credibility. Those remain essential, but today’s mandates increasingly ask finance leaders to own transformation, data, and operational performance.',
      'This broadens the candidate pool in useful ways. Leaders with operating, strategy, or private equity backgrounds can be compelling — provided the search tests rigorously for technical depth.',
      'We advise clients to define which of the CFO’s roles — steward, strategist, operator, or catalyst — matters most over the next three years, and to assess candidates explicitly against that weighting.',
    ],
  },
  {
    slug: 'interim-leaders-as-strategy',
    title: 'Interim leaders as a strategic choice, not a stopgap',
    category: 'Interim Leadership',
    date: '2026-07-14',
    readTime: '4 min read',
    excerpt:
      'Experienced interim executives can de-risk transformation and buy boards time to make the right permanent hire.',
    body: [
      'Interim executives are often brought in reactively after an unexpected departure. Yet some of the most effective uses are planned: leading a defined transformation, integrating an acquisition, or preparing a function for a permanent leader.',
      'Because interim leaders carry no long-term career agenda inside the organization, they can make difficult decisions quickly and objectively.',
      'The key is a precise brief with clear milestones and an agreed handover — so the permanent appointee inherits momentum rather than ambiguity.',
    ],
  },
  {
    slug: 'assessing-leadership-potential',
    title: 'Assessing leadership potential with evidence, not instinct',
    category: 'Assessment',
    date: '2026-06-02',
    readTime: '7 min read',
    excerpt:
      'Structured assessment reduces bias and improves outcomes. A practical framework for executive selection.',
    body: [
      'Interview panels consistently overestimate their ability to judge leadership potential from conversation alone. Structured approaches — consistent questions, scored against a defined success profile — produce materially better decisions.',
      'We combine competency-based interviewing with deep referencing, work-sample discussions tied to the actual challenges of the role, and, where helpful, psychometric input.',
      'The aim is not to replace judgment, but to give boards and hiring executives a shared, evidence-based view of each candidate before the final decision.',
    ],
  },
];
